"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const FractalGeometryVisualization = () => {
    const canvasRef = (0, react_1.useRef)(null);
    const [fractalType, setFractalType] = (0, react_1.useState)('mandelbrot');
    const [juliaConstant, setJuliaConstant] = (0, react_1.useState)({ real: -0.7, imag: 0.27 });
    const [viewport, setViewport] = (0, react_1.useState)({
        centerX: -0.5,
        centerY: 0,
        zoom: 1
    });
    const [isDragging, setIsDragging] = (0, react_1.useState)(false);
    const [dragStart, setDragStart] = (0, react_1.useState)({ x: 0, y: 0 });
    const [maxIterations, setMaxIterations] = (0, react_1.useState)(100);
    const [isRendering, setIsRendering] = (0, react_1.useState)(false);
    const width = 800;
    const height = 600;
    const renderFractal = (0, react_1.useCallback)((currentFractalType = fractalType) => __awaiter(void 0, void 0, void 0, function* () {
        console.log(`Starting render for ${currentFractalType} fractal`);
        const canvas = canvasRef.current;
        if (!canvas) {
            console.error('Canvas not found');
            return;
        }
        setIsRendering(true);
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return;
        // Clear canvas
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, width, height);
        // Calculate the complex plane bounds
        const aspectRatio = width / height;
        const scale = 4 / viewport.zoom;
        const left = viewport.centerX - scale * aspectRatio / 2;
        const right = viewport.centerX + scale * aspectRatio / 2;
        const top = viewport.centerY + scale / 2;
        const bottom = viewport.centerY - scale / 2;
        // Use Web Workers for parallel processing
        const workerCount = navigator.hardwareConcurrency || 4;
        const rowsPerWorker = Math.ceil(height / workerCount);
        const workers = [];
        const promises = [];
        // Create a single worker code template
        const workerCode = `
            function calculateMandelbrot(cReal, cImag, maxIterations) {
                let zReal = 0;
                let zImag = 0;
                let iterations = 0;
                
                while (iterations < maxIterations) {
                    const zReal2 = zReal * zReal;
                    const zImag2 = zImag * zImag;
                    if (zReal2 + zImag2 > 4) return iterations;
                    
                    const newZImag = 2 * zReal * zImag + cImag;
                    zReal = zReal2 - zImag2 + cReal;
                    zImag = newZImag;
                    iterations++;
                }
                return maxIterations;
            }

            function calculateJulia(zReal, zImag, cReal, cImag, maxIterations) {
                let iterations = 0;
                
                while (iterations < maxIterations) {
                    const zReal2 = zReal * zReal;
                    const zImag2 = zImag * zImag;
                    if (zReal2 + zImag2 > 4) return iterations;
                    
                    const newZImag = 2 * zReal * zImag + cImag;
                    zReal = zReal2 - zImag2 + cReal;
                    zImag = newZImag;
                    iterations++;
                }
                return maxIterations;
            }

            function calculateBurningShip(cReal, cImag, maxIterations) {
                let zReal = 0;
                let zImag = 0;
                let iterations = 0;
                
                while (iterations < maxIterations) {
                    const zReal2 = zReal * zReal;
                    const zImag2 = zImag * zImag;
                    if (zReal2 + zImag2 > 4) return iterations;
                    
                    const newZReal = zReal2 - zImag2 + cReal;
                    const newZImag = 2 * Math.abs(zReal) * Math.abs(zImag) + cImag;
                    
                    zReal = newZReal;
                    zImag = newZImag;
                    iterations++;
                }
                return maxIterations;
            }

            self.onmessage = function(e) {
                const { width, height, left, right, top, bottom, maxIterations, startY, endY, cReal, cImag, type } = e.data;
                const results = [];
                const stepX = (right - left) / width;
                const stepY = (top - bottom) / height;

                for (let y = startY; y < endY; y++) {
                    for (let x = 0; x < width; x++) {
                        const real = left + x * stepX;
                        const imag = top - y * stepY;
                        try {
                            if (type === 'mandelbrot') {
                                results.push(calculateMandelbrot(real, imag, maxIterations));
                            } else if (type === 'julia') {
                                results.push(calculateJulia(real, imag, cReal || -0.7, cImag || 0.27, maxIterations));
                            } else if (type === 'burningShip') {
                                results.push(calculateBurningShip(real, imag, maxIterations));
                            }
                        } catch (err) {
                            console.error('Calculation error:', err);
                            results.push(0);
                        }
                    }
                }
                self.postMessage({ results, startY, endY });
            };
        `;
        console.log(`Creating ${workerCount} workers for ${currentFractalType}`);
        for (let i = 0; i < workerCount; i++) {
            const startY = i * rowsPerWorker;
            const endY = Math.min(startY + rowsPerWorker, height);
            console.log(`Worker ${i} processing rows ${startY}-${endY}`);
            const worker = new Worker(URL.createObjectURL(new Blob([workerCode], { type: 'application/javascript' })));
            workers.push(worker);
            promises.push(new Promise(resolve => {
                worker.onmessage = (e) => resolve(e.data);
            }));
            worker.postMessage({
                width,
                height,
                left,
                right,
                top,
                bottom,
                maxIterations,
                startY,
                endY,
                cReal: juliaConstant.real,
                cImag: juliaConstant.imag,
                type: currentFractalType
            });
            console.log(`Sent parameters to worker ${i}:`, {
                type: currentFractalType,
                cReal: juliaConstant.real,
                cImag: juliaConstant.imag
            });
        }
        // Wait for all workers to finish
        console.log('Waiting for worker results...');
        const workerResults = yield Promise.all(promises);
        console.log(`Received results from ${workerResults.length} workers`);
        if (!ctx) {
            workers.forEach(worker => worker.terminate());
            setIsRendering(false);
            return;
        }
        // Create image data
        const fractalImageData = ctx.createImageData(width, height);
        const pixelData = fractalImageData.data;
        // Combine results from all workers
        for (const result of workerResults) {
            const { results, startY } = result;
            for (let i = 0; i < results.length; i++) {
                const x = i % width;
                const y = startY + Math.floor(i / width);
                const pixelIndex = (y * width + x) * 4;
                const iterations = results[i];
                if (iterations === maxIterations) {
                    // Point is in the set (black)
                    pixelData[pixelIndex] = 0;
                    pixelData[pixelIndex + 1] = 0;
                    pixelData[pixelIndex + 2] = 0;
                    pixelData[pixelIndex + 3] = 255;
                }
                else {
                    // Simple coloring for better performance
                    const colorIntensity = iterations / maxIterations;
                    pixelData[pixelIndex] = Math.floor(255 * colorIntensity);
                    pixelData[pixelIndex + 1] = Math.floor(128 * colorIntensity);
                    pixelData[pixelIndex + 2] = Math.floor(255 * (1 - colorIntensity));
                    pixelData[pixelIndex + 3] = 255;
                }
            }
        }
        ctx.putImageData(fractalImageData, 0, 0);
        setIsRendering(false);
        // Clean up workers
        workers.forEach(worker => worker.terminate());
    }), [viewport, maxIterations, width, height]);
    // Reset view when fractal type changes
    (0, react_1.useEffect)(() => {
        console.log('Resetting view for new fractal type:', fractalType);
        setViewport({
            centerX: fractalType === 'mandelbrot' ? -0.5 : 0,
            centerY: 0,
            zoom: 1
        });
    }, [fractalType]);
    // Handle fractal rendering
    (0, react_1.useEffect)(() => {
        console.log('Rendering fractal:', fractalType);
        let workers = [];
        // Terminate any existing workers when changing fractal type
        const cleanup = () => {
            workers.forEach((worker) => worker.terminate());
            setIsRendering(false);
        };
        const render = () => __awaiter(void 0, void 0, void 0, function* () {
            yield renderFractal(fractalType);
        });
        render();
        return cleanup;
    }, [renderFractal, fractalType, juliaConstant]);
    const handleMouseDown = (e) => {
        setIsDragging(true);
        setDragStart({ x: e.clientX, y: e.clientY });
    };
    const handleMouseMove = (e) => {
        if (!isDragging)
            return;
        const deltaX = e.clientX - dragStart.x;
        const deltaY = e.clientY - dragStart.y;
        const scale = 4 / viewport.zoom;
        const aspectRatio = width / height;
        setViewport(prev => (Object.assign(Object.assign({}, prev), { centerX: prev.centerX - (deltaX / width) * scale * aspectRatio, centerY: prev.centerY + (deltaY / height) * scale })));
        setDragStart({ x: e.clientX, y: e.clientY });
    };
    const handleMouseUp = () => {
        setIsDragging(false);
    };
    const handleWheel = (e) => {
        e.preventDefault();
        const zoomFactor = e.deltaY > 0 ? 1.2 : 0.8;
        setViewport(prev => (Object.assign(Object.assign({}, prev), { zoom: Math.max(0.1, Math.min(10000, prev.zoom * zoomFactor)) })));
    };
    const resetView = () => {
        setViewport({
            centerX: -0.5,
            centerY: 0,
            zoom: 1
        });
    };
    const zoomToPoint = (x, y) => {
        const scale = 4 / viewport.zoom;
        const aspectRatio = width / height;
        const complexX = viewport.centerX + (x - width / 2) / width * scale * aspectRatio;
        const complexY = viewport.centerY - (y - height / 2) / height * scale;
        setViewport(prev => ({
            centerX: complexX,
            centerY: complexY,
            zoom: Math.min(10000, prev.zoom * 2)
        }));
    };
    const handleCanvasClick = (e) => {
        var _a;
        if (isDragging)
            return;
        const rect = (_a = canvasRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!rect)
            return;
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        zoomToPoint(x, y);
    };
    return (react_1.default.createElement("div", { className: "fractal-visualization" },
        react_1.default.createElement("div", { className: "visualization-header" },
            react_1.default.createElement("h1", null,
                "Fractal Geometry: ",
                fractalType === 'mandelbrot' ? 'Mandelbrot Set' :
                    fractalType === 'julia' ? 'Julia Set' : 'Burning Ship'),
            react_1.default.createElement("p", null, "Explore the infinite complexity of fractals. Click to zoom in, drag to pan, and use the mouse wheel to zoom. The colors represent how quickly points escape to infinity.")),
        react_1.default.createElement("div", { className: "controls" },
            react_1.default.createElement("div", { className: "control-group" },
                react_1.default.createElement("label", { htmlFor: "fractal-type" }, "Fractal Type:"),
                react_1.default.createElement("select", { id: "fractal-type", value: fractalType, onChange: (e) => setFractalType(e.target.value) },
                    react_1.default.createElement("option", { value: "mandelbrot" }, "Mandelbrot Set"),
                    react_1.default.createElement("option", { value: "julia" }, "Julia Set"),
                    react_1.default.createElement("option", { value: "burningShip" }, "Burning Ship"))),
            react_1.default.createElement("div", { className: "control-group" },
                react_1.default.createElement("label", { htmlFor: "iterations" }, "Max Iterations:"),
                react_1.default.createElement("input", { id: "iterations", type: "range", min: "50", max: "500", value: maxIterations, onChange: (e) => setMaxIterations(parseInt(e.target.value)) }),
                react_1.default.createElement("span", null, maxIterations)),
            react_1.default.createElement("button", { onClick: resetView, className: "reset-button" }, "Reset View"),
            isRendering && react_1.default.createElement("div", { className: "rendering-indicator" }, "Rendering...")),
        react_1.default.createElement("div", { className: "canvas-container" },
            react_1.default.createElement("canvas", { ref: canvasRef, width: width, height: height, onMouseDown: handleMouseDown, onMouseMove: handleMouseMove, onMouseUp: handleMouseUp, onMouseLeave: handleMouseUp, onWheel: handleWheel, onClick: handleCanvasClick, style: {
                    cursor: isDragging ? 'grabbing' : 'grab',
                    border: '1px solid #333',
                    borderRadius: '8px'
                } })),
        react_1.default.createElement("div", { className: "info-panel" },
            react_1.default.createElement("h3", null,
                "About ",
                fractalType === 'mandelbrot' ? 'the Mandelbrot Set' :
                    fractalType === 'julia' ? 'Julia Sets' : 'the Burning Ship'),
            react_1.default.createElement("p", null,
                fractalType === 'mandelbrot' ?
                    'The Mandelbrot Set is defined as the set of complex numbers c for which the sequence z₀ = 0, zₙ₊₁ = zₙ² + c does not diverge.' :
                    fractalType === 'julia' ?
                        'Julia Sets are defined for a fixed complex parameter c, showing the set of points z₀ where the sequence zₙ₊₁ = zₙ² + c remains bounded.' :
                        'The Burning Ship fractal uses the formula zₙ₊₁ = (|Re(zₙ)| + i|Im(zₙ)|)² + c, creating distinctive "ship-like" structures.',
                "Points in the set (black) remain bounded, while points outside (colored) escape to infinity at different rates."),
            react_1.default.createElement("p", null,
                react_1.default.createElement("strong", null, "Current View:"),
                " Center: (",
                viewport.centerX.toFixed(6),
                ", ",
                viewport.centerY.toFixed(6),
                "), Zoom: ",
                viewport.zoom.toFixed(2),
                "x"))));
};
exports.default = FractalGeometryVisualization;
